<script>
import { Doughnut } from "vue-chartjs";
import Chart from "chart.js";

export default {
  extends: Doughnut,
  props: ["chartData"],
  data: () => ({
    options: {
      legend: {
        display: true,
        borderRadius: 50,
        position: "bottom",
        boxWidth: "20px"
      },
      cutoutPercentage: 75,
      responsive: true,
      maintainAspectRatio: false
    }
  }),
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
  methods: {
    textCenter(val) {
      Chart.pluginService.register({
        beforeDraw: function(chart) {
          let width = chart.chart.width;
          let height = chart.chart.height;
          let ctx = chart.chart.ctx;

          ctx.restore();
          let fontSize = (height / 200).toFixed(2);
          ctx.font = fontSize + "em sans-serif";
          ctx.textBaseline = "middle";

          let text = val;
          let textX = Math.round((width - ctx.measureText(text).width) / 2);
          let textY = height / 2;
          ctx.fillText(text, textX, textY);
          ctx.save();
        }
      });

      Chart.plugins.unregister(this.chartData);
    }
  }
};
</script>
